import Vue from 'vue';
import "font-awesome/css/font-awesome.min.css";
import "./index.scss"
import VueLazyload from 'vue-lazyload';
import 'lib-flexible/flexible';

import {
  InfiniteScroll,
  Progress,
  Spinner
} from 'mint-ui';
Vue.use(InfiniteScroll);
Vue.component(Progress.name, Progress);
Vue.component(Spinner.name, Spinner);

import {
  getVideoList
} from "../../api/server";
Vue.use(VueLazyload)
import fastclick from 'fastclick';


fastclick.attach(document.body); // 解决移动端响应延迟问题

new Vue({
  el: '#app',
  data() {
    return {
      videoList: [], // 列表数据
      id: 1,
      loading: true,
      touchst: false, // 页面初始化取消下拉加载
      showLoading: false, // 控制显示加载更多
      IsShowBody: false,
    };
  },

  mounted() {
    this.searchData();
  },
  methods: {
    loadMore() {
      // 下拉加载
      if (!this.touchst) {
        return;
      }
      this.showLoading = true;
      this.id++;
      this.searchData();
    },
    searchData() {
      var param = {};
      param.companyId = document.getElementById("CompanyId").value;
      param.ContentVideoId = document.getElementById("ContentVideoId").value;
      param.GroupId = document.getElementById("GroupId").value;
      param.SearchValue = document.getElementById("searchInput").value;
      param.pageindex = this.id;
      getVideoList(param).then(res => {
        // 请求数据
        this.videoList = this.videoList.concat(res);
        console.log(this.videoList);
        if (res.length > 0) {
          this.touchst = true;
        } else {
          this.touchst = false;
        }
        setTimeout(() => {
          this.IsShowBody = true;
        }, 1000)

        this.showLoading = false;
      });
    },
    Search() {
      console.log("搜索");
      this.videoList = [];
      this.showLoading = true;
      this.IsShowBody = false;
      this.searchData();
    }
  }
});



// WEBPACK FOOTER //
// ./src/pages/VideoPlayList/Content/index.js